import React, { useState } from 'react'
//import './FilterForm.css'
import {localestr} from '../utils.js'
import EditCtrl from './EditCtrl'

function RangeForm({from,to,setModal,action}){
    const [frm,setFrom_]=useState(from)
    const [to_,setTo_]=useState(to)

    let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;

    function setFrom(val){
      setFrom_(val)
      if(val>to_){
        const tempDate = new Date(val)
        tempDate.setHours(23,59,59,999)
        setTo_(tempDate)
      }
    }

    function setTo(val){
      setTo_(val)
      if(val<frm){
        const tempDate = new Date(val)
        tempDate.setHours(0,0,0,0)
        setFrom_(tempDate)
      } 
    }

    function setRange(val){
        let d1=new Date()
        let d2=new Date()
        d1.setHours(0,0,0,0)
        d2.setHours(23,59,59,999)
        if(val==='yesterday'){
          d1.setDate(d1.getDate()-1)
          d2.setDate(d2.getDate()-1)
        } else if(val==='currweek'){
          let d3=d1.getDay()-1
          if (d3===-1) d3=6
          d1.setDate(d1.getDate()-d3)
        } else if(val==='lastweek'){
          let d3=d1.getDay()
          if (d3===0) d3=7
          d2.setDate(d1.getDate()-d3)
          d1.setDate(d2.getDate()-6)
        } else if(val==='currmonth'){
          d1.setDate(1)
        } else if(val==='lastmonth'){
          d2.setDate(0)
          d1.setMonth(d1.getMonth()-1,1)
        }
        setFrom_(d1)
        setTo_(d2)
    }

    function dragMouseDown(e) {
        e = e || window.event;
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
    }
    
    function elementDrag(e) {
        const elmnt=document.getElementById('modalWnd')
        e = e || window.event;
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        // set the element's new position:
        if (pos2!==0) elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
        if (pos1!==0) elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    }
    
      function closeDragElement() {
        /* stop moving when mouse button is released:*/
        document.onmouseup = null;
        document.onmousemove = null;
      }
      //дописати сьогодні, вчора, поточ. тиждень, минул тиждень, поточ місяць, минул місяць

    return(
        <div className='modal_f'><div id='modalWnd' className='window'>
            <div onMouseDown={dragMouseDown} style={{flexDirection:'row',display:'flex',justifyContent:'flex-start'}}><div className='caption'>{localestr('Інтервал дат')}</div><div className='closebtn' onClick={()=>{setModal('')}}/></div>
            <div className='content' style={{overflow:'unset'}}>
            <div style={{margin:'5px 0 0 0',display:'flex',justifyContent:'center'}}>
            <EditCtrl Capt={localestr('з')} Value={frm} typeVal={'datetime'} setVal={setFrom} width1='20' width2='160'/>
            <EditCtrl Capt={localestr('по')} Value={to_} typeVal={'datetime'} setVal={setTo} width1='20' width2='160'/>
            </div>
            <div style={{margin:'5px 0 0 0',display:'flex',justifyContent:'center'}}>
            <div style={{width:'130px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setRange('today')}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Сьогодні')}</div></div>
            <div style={{width:'130px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setRange('currweek')}}><div style={{height:'30px',lineHeight:'15px',display:'block'}}>{localestr('Поточний тиждень')}</div></div>
            <div style={{width:'130px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setRange('currmonth')}}><div style={{height:'30px',lineHeight:'15px',display:'block'}}>{localestr('Поточний місяць')}</div></div>
            </div>
            <div style={{margin:'-5px 0 0 0',display:'flex',justifyContent:'center'}}>
            <div style={{width:'130px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setRange('yesterday')}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Вчора')}</div></div>
            <div style={{width:'130px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setRange('lastweek')}}><div style={{height:'30px',lineHeight:'15px',display:'block'}}>{localestr('Минулий тиждень')}</div></div>
            <div style={{width:'130px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setRange('lastmonth')}}><div style={{height:'30px',lineHeight:'15px',display:'block'}}>{localestr('Минулий місяць')}</div></div>
            </div>
            <div style={{margin:'10px 0 0 0',display:'flex',justifyContent:'center'}}>
            <div style={{width:'80px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{action(frm,to_);setModal('')}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>OK</div></div>
            <div style={{width:'80px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setModal('')}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Закрити')}</div></div>
            </div>
            
            </div>
        </div></div>
    )
}

export default RangeForm